import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { EMPTY, catchError } from "rxjs";
import { MacAddressService } from "../../services/mac-address.service";
import { MacAddressRequest } from "../../models/mac-address";
import { MacAddressResultModalComponent } from "../../modals/mac-address-result-modal/mac-address-result-modal.component";
import { AddressValidators } from "../../validators/address.validator";
import { ModalService } from "../../services/modal.service";
import { SnackBarService } from "../../services/snackbar.service";

@Component({
  selector: 'dl-mac-address-form',
  templateUrl: './mac-address-form.component.html',
  styleUrl: './mac-address-form.component.scss',
  encapsulation : ViewEncapsulation.None,
  changeDetection : ChangeDetectionStrategy.OnPush,
})

export class MacAddressFormComponent {

  public readonly SERIAL_NUMBER_LIMIT = 300;
  public readonly rows = 5;
  public readonly cols = 70;
  public macAddressForm: FormGroup;
  public disabled = true;

  constructor(private fb: FormBuilder, private addressService: MacAddressService,
      private modalService : ModalService, private snackBarService : SnackBarService
  ) {
      this.macAddressForm = this.fb.group({
          macAddresses: [null, [
            Validators.required, 
            AddressValidators.maxSerialnumberNumbers(this.SERIAL_NUMBER_LIMIT)
        ]]
      });
  }

  ngOnInit() : void {

  }

  sendMacAddressRequest() : void {
      const macAddresses = this.addressService.createSerialNumberArray(this.macAddressForm.controls["macAddresses"].value);
      const request: MacAddressRequest = { serialNumber: macAddresses };
      this.addressService.getMacAddresses(request).pipe(catchError(() => {
          this.openErrorSnackBar();
          return EMPTY;
      })).subscribe((macAddresses) => this.openMacAddressResultModal(macAddresses));
  }

  private openMacAddressResultModal(macAddresses: any[]): void {
      this.modalService.showModal(MacAddressResultModalComponent, macAddresses);
  }

  private openErrorSnackBar() {
      const errorMessage = `Something went wrong. Please wait a few minutes before you try again.`;
      this.snackBarService.showError(errorMessage);
  }

}
